export default __webpack_public_path__ + "static/logo-4b553d3f41bc02fceb428f4e427de03b.png";